var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCarrosacentroamerica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 34,
    viewBox: "0 0 92 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.592 2.29297C8.47794 2.29297 1.99805 8.97361 1.99805 17.1172C1.99805 25.3253 8.47794 31.8782 16.592 31.8782C20.4294 31.8782 24.2668 30.2875 26.9708 27.5514L21.4992 22.0161C20.1779 23.3524 18.5426 24.0523 16.592 24.0523C12.8183 24.0523 9.73545 20.9352 9.73545 17.1172C9.73545 13.3637 12.7546 10.1189 16.592 10.1189C18.4163 10.1189 20.1779 10.882 21.4992 12.1551L26.9708 6.61973C24.2668 3.88371 20.4294 2.29297 16.592 2.29297Z",
    fill: "#061E3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0041 2.29297C42.89 2.29297 36.4102 8.97361 36.4102 17.1172C36.4102 25.3253 42.89 31.8782 51.0041 31.8782C54.8415 31.8782 58.6789 30.2875 61.3829 27.5514L55.9113 22.0161C54.59 23.3524 52.9547 24.0523 51.0041 24.0523C47.2305 24.0523 44.1476 20.9352 44.1476 17.1172C44.1476 13.3637 47.1667 10.1189 51.0041 10.1189C52.8284 10.1189 54.59 10.882 55.9113 12.1551L61.3829 6.61973C58.6789 3.88371 54.8415 2.29297 51.0041 2.29297Z",
    fill: "#061E3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2612 2.29297V4.07478C80.1229 2.86619 77.7956 2.29297 75.342 2.29297C67.2279 2.29297 60.748 8.97361 60.748 17.1172C60.748 25.3253 67.2279 31.8782 75.342 31.8782C77.8582 31.8782 80.1854 31.2417 82.2612 30.1608V31.8782H89.9986V2.29297H82.2612ZM75.342 24.0523C71.5683 24.0523 68.4855 20.9352 68.4855 17.1172C68.4855 13.2359 71.5683 10.1189 75.342 10.1189C79.1794 10.1189 82.2612 13.2359 82.2612 17.1172C82.2612 20.9352 79.1794 24.0523 75.342 24.0523Z",
    fill: "#061E3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5488 17.0603H33.6044",
    stroke: "#061E3C",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCarrosacentroamerica);
export default __webpack_public_path__ + "static/media/logo_carrosacentroamerica.49ef278d2c54f2f88b56a8ea973c653e.svg";
export { ForwardRef as ReactComponent };